import { useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { URLS } from "@const/urls";

const KR_PREVIEW_URL = "https://d257kvs4acsh7t.cloudfront.net/";
const INTL_PREVIEW_URL = "https://dgklsgs33ap3q.cloudfront.net/";
const JP_PREVIEW_URL = "https://d1c8idxzjd63t3.cloudfront.net/";

const KR_PROD_URL = "https://thisisneverthat.com/";
const INTL_PROD_URL = "https://intl.thisisneverthat.com/";
const JP_PROD_URL = "https://thisisneverthat.jp/";

export default function useCheckLocation() {
  const { pathname } = useLocation();

  // matchPath는 pathname(route path)만 비교 가능
  const isCheckout = useMemo(
    () => Boolean(matchPath(URLS.CHECKOUT, pathname)) || Boolean(matchPath(URLS.CHECKOUT_PAYMENT, pathname)),
    [pathname],
  );
  const isHome = useMemo(() => Boolean(matchPath(URLS.HOME, pathname)), [pathname]);
  const isVideoDetail = useMemo(() => Boolean(matchPath(URLS.VIDEO_DETAIL, pathname)), [pathname]);
  const isWeChat = useMemo(() => Boolean(matchPath(URLS.WECHAT, pathname)), [pathname]);
  const isCollection = useMemo(() => Boolean(pathname.includes(URLS.COLLECTIONS_DETAIL)), [pathname]);
  const isSearch = useMemo(() => Boolean(pathname.includes(URLS.SEARCH)), [pathname]);
  const isProduct = useMemo(() => Boolean(matchPath(URLS.PRODUCTS_DETAIL, pathname)), [pathname]);
  const isOrderCompleted = useMemo(() => Boolean(matchPath(URLS.ORDER_COMPLETED, pathname)), [pathname]);
  const isFeatures = useMemo(
    () => pathname === URLS.FEATURES || pathname === URLS.NEWS || pathname === URLS.LOOKBOOK || pathname === URLS.VIDEO,
    [pathname],
  );
  const isStore = useMemo(() => pathname === URLS.STORES, [pathname]);
  const isAccount = useMemo(() => pathname === URLS.ORDER_HISTORY || pathname === URLS.ACCOUNT || pathname === URLS.ADDRESSES, [pathname]);
  const isInformation = useMemo(() => pathname.includes(URLS.INFORMATION), [pathname]);

  const isFeaturesDetail = useMemo(() => pathname.includes(URLS.FEATURES), [pathname]);
  const isDanielJohnston = window.location.href.includes("daniel-johnston");

  const isKr = window.location.href.includes(KR_PREVIEW_URL) || window.location.href.includes(KR_PROD_URL);
  const isIntl = window.location.href.includes(INTL_PREVIEW_URL) || window.location.href.includes(INTL_PROD_URL);
  const isJp = window.location.href.includes(JP_PREVIEW_URL) || window.location.href.includes(JP_PROD_URL);
  const isPreview =
    window.location.href.includes(KR_PREVIEW_URL) ||
    window.location.href.includes(INTL_PREVIEW_URL) ||
    window.location.href.includes(JP_PREVIEW_URL);
  const isProd =
    window.location.href.includes(KR_PROD_URL) ||
    window.location.href.includes(INTL_PROD_URL) ||
    window.location.href.includes(JP_PROD_URL);
  const isLocal = window.location.href.includes("localhost") || window.location.href.includes("ngrok");

  return {
    isCheckout,
    isHome,
    isVideoDetail,
    isCollection,
    isProduct,
    isKr,
    isIntl,
    isJp,
    isPreview,
    isProd,
    isLocal,
    isWeChat,
    isDanielJohnston,
    isFeatures,
    isFeaturesDetail,
    isSearch,
    isAccount,
    isOrderCompleted,
    isStore,
    isInformation,
  };
}
